import template from './templates/data-capture.tmpl';

import localize from   '../../core/localize';

import AppSettings from '../../core/AppSettings';

import  DataCaptureHelper  from '../../core/dataCapture/DataCaptureHelper';

import  EmailCaptureHelper  from '../../core/dataCapture/EmailCaptureHelper';

import { error } from 'jquery';

import {hasSomeParentTheClass} from '../../core/utils';

export default class DataCapture {
	constructor (parentElement, options = {}) {

		this.parentElement = parentElement;
		this.renderedTemplate = template;

		this.el = document.createElement('div');
		this.el.className= 'data-capture';
		this.el.innerHTML = this.renderedTemplate;
		
		this.dc_el = this.el.querySelector('#datacapture');
		this.email_el = this.el.querySelector('#emailcapture');

		this.dataCaptureEnabled = AppSettings.isDataCaptureEnabled();
		this.emailCaptureEnabled = AppSettings.isEmailCaptureEnabled();
		
		if(this.dataCaptureEnabled) {
			this.datacaptureFields = AppSettings.client.CustomDataCapture;
		}

		const preview = this.parentElement.querySelector('.preview');
		this.parentElement.insertBefore(this.el, preview);
		preview.classList.add('hide');

		localize(this.el, AppSettings.Language);

		this.onClose = options.onClose || (() => {});
		this.onNext = options.onNext || (() => {});

		this.el.querySelector('#dc--btn-back').onclick = () => {
			this.parentElement.removeChild(this.el);
			this.onClose();
		};

		this.el.querySelector('#dc--btn-next').onclick = () => {
			const errors = this.getAllValidations();

			if (errors.length === 0) {
				if(this.dataCaptureEnabled) {
					const dc_values = this.dc_helper.getValues(false);
				}

				if(this.emailCaptureEnabled) {
					const email_value = this.email_helper.getEmailValue(false);
				}
				
				this.onNext();
			}
		};

		/* Create email & DC fields */
		this.renderContainer(this.datacaptureFields);

		/* Check if input fields are getting filled with passthrough */
		this.checkPrefilledFields();

		
		////////////////// DataCapture transitions starts here
		const that = this;

		if(this.dataCaptureEnabled) {
			/* Floating label transitions on Data Capture fields */
			const dc_inputs = this.el.querySelectorAll('.dcElement');
			[].forEach.call(dc_inputs, function(el) {

				/* blur event on all text based inputs */
				el.addEventListener('blur', (e) => {
					if(!e.currentTarget.classList.contains('ssg-dropdown') && !e.currentTarget.classList.contains('input-checkbox')) {
						that.dc_helper.getValidations(e);
					}
				});

				/* keypress event on all text based inputs */
				el.addEventListener('keypress', (e) => {
					let keyCode = e.keyCode || e.which; 
					if (keyCode == 9) { // Tab key
						e.preventDefault();
						that.dc_helper.getValidations(e);
					}
					else {
						e.currentTarget.parentElement.classList.remove('error-input-wrap');
					}
				});
			});
			
			/* Floating label transitions on change event of custom dropdown */
			this.el.querySelector('.ssg-dropdown').addEventListener('change', (e) => {
				this.dc_helper.getValidations(e);
			});

			/* Floating label transitions on click event of custom checkbox */
			this.el.querySelector('.input-checkbox').addEventListener('click', (e) => {
				const el = e.currentTarget;
				const checkbox_wrap = hasSomeParentTheClass(el, 'checkbox');

				if(el.checked == true){
					checkbox_wrap.classList.add('checkbox-checked');
				}
				else {
					checkbox_wrap.classList.remove('checkbox-checked');
				}
				
				this.dc_helper.getValidations(e);
			});
		}

		
		if(this.emailCaptureEnabled) {
			/* Floating label transitions on Email Capture fields */
			const email_inputs = this.el.querySelectorAll('.emailElement');
			[].forEach.call(email_inputs, function(el) {

				/* blur event on all inputs */
				el.addEventListener('blur', (e) => {
					that.email_helper.getValidations(e);
				});

				/* keypress event on all inputs */
				el.addEventListener('keypress', (e) => {
					let keyCode = e.keyCode || e.which; 
					if (keyCode == 9) { // Tab key
						e.preventDefault();
						that.email_helper.getValidations(e);
					}
					else {
						e.currentTarget.parentElement.classList.remove('error-input-wrap');
					}
				});
			});
		}
		////////////////// DataCapture transitions ends here

	}

	renderContainer(items){
		const langData = AppSettings.Language;
		let templateMessages = {
			checkbox: {
				invalid: langData.dataCapture && langData.dataCapture.errorCheckbox ? langData.dataCapture.errorCheckbox : 'dataCapture.errorCheckbox'},
			regexp: {
				invalid: langData.dataCapture && langData.dataCapture.errorBadRegExp ? langData.dataCapture.errorBadRegExp : 'dataCapture.errorBadRegExp',
				numericOnly: langData.dataCapture && langData.dataCapture.errorBadFormat ? langData.dataCapture.errorBadFormat : 'dataCapture.errorBadFormat'
			},
			input: {
				length: langData.dataCapture && langData.dataCapture.errorBadLength ? langData.dataCapture.errorBadLength : 'dataCapture.errorBadLength'
			},
			email: {
				invalid: langData.dataCapture && langData.dataCapture.errorInvalidEmail ? langData.dataCapture.errorInvalidEmail : 'dataCapture.errorInvalidEmail',
				mandatory: langData.dataCapture && langData.dataCapture.errorEnterEmail ? langData.dataCapture.errorEnterEmail : 'dataCapture.errorEnterEmail',
				label: langData.dataCapture && langData.dataCapture.enterEmail ? langData.dataCapture.enterEmail : 'dataCapture.enterEmail',
				confirmlabel: langData.dataCapture && langData.dataCapture.confirmEmail ? langData.dataCapture.confirmEmail : 'dataCapture.confirmEmail',
				nomatch: langData.dataCapture && langData.dataCapture.errorEmailDoesNotMatch ? langData.dataCapture.errorEmailDoesNotMatch : 'dataCapture.errorEmailDoesNotMatch'
			},
			mandatory: langData.dataCapture && langData.dataCapture.errorEmptyField ? langData.dataCapture.errorEmptyField : 'dataCapture.errorEmptyField',
			dropdown: {
				invalid: langData.dataCapture && langData.dataCapture.errorInvalidDropdown ? langData.dataCapture.errorInvalidDropdown : 'dataCapture.errorInvalidDropdown'
			}
		};

		/* render DC fields */
		this.dataCaptureEnabled 
			? this.dc_helper = new DataCaptureHelper(this.dc_el, items, templateMessages) 
			: this.el.querySelector('.dc-wrap').classList.add('hide');

		/* render Email fields */
		this.emailCaptureEnabled
			? this.email_helper = new EmailCaptureHelper(this.email_el, templateMessages)
			: this.el.querySelector('.email-wrap').classList.add('hide');
	}
	
	getAllValidations(){
		let errors = [];

		if (this.dataCaptureEnabled && !this.emailCaptureEnabled) {
			errors = this.dc_helper.getValidations();
		}
		else if (!this.dataCaptureEnabled && this.emailCaptureEnabled) {
			errors = this.email_helper.getValidations();
		}
		else if (this.dataCaptureEnabled && this.emailCaptureEnabled) {
			let error1 = [], error2 = [];
			error1 = this.email_helper.getValidations();
			error2 = this.dc_helper.getValidations();
			errors = error1.concat(error2);
		}

		return errors;
	}

	checkPrefilledFields(){
		const input_fields = this.el.querySelectorAll('.input-transition-effect');
		[].forEach.call(input_fields, function(el) {
			if(el.value != '' && el.value != undefined) {
				el.classList.add('has-content');
			}
		});
	}
}
